export const getConsultant = (consultantID) => ({ consultants }) =>
  consultants.consultantsList.find(({ id }) => id === consultantID);
